export default __webpack_public_path__ + "static/media/forex-vps-net-dark.237c60d5.svg";